import * as React from 'react';
import { LoggedInUserProps, withLoggedInUser } from './withLoggedInUser';

interface ChildrenProps {
    children?: any;
    showIfLoggedIn: boolean;
    showLoader?: boolean;
    loading?: boolean;
    error?: any;
}

type ShowOrHideIfLoggedInProps = ChildrenProps & LoggedInUserProps;

class ShowOrHideIfLoggedIn extends React.Component<
    ShowOrHideIfLoggedInProps,
    any
> {
    public render() {
        const { children, showIfLoggedIn, loggedInUser, loading } = this.props;
        const loggedIn = !!loggedInUser;

        if (loading) {
            return null;
        }

        if (showIfLoggedIn === loggedIn) {
            return React.Children.map(children, child => {
                if (React.isValidElement(child)) {
                    return React.cloneElement(child);
                }
                return child;
            });
        }
        return null;
    }
}

// Pass the current logged in user using the withLoggedInUser HOC
const ShowOrHideIfLoggedInWithData = withLoggedInUser(ShowOrHideIfLoggedIn);

export const ShowIfLoggedIn = ({ children }: { children?: any }) => (
    <ShowOrHideIfLoggedInWithData showIfLoggedIn={true} children={children} />
);

export const HideIfLoggedIn = ({ children }: { children?: any }) => (
    <ShowOrHideIfLoggedInWithData showIfLoggedIn={false} children={children} />
);



// WEBPACK FOOTER //
// ./src/client/components/Login/ShowIfLoggedIn.tsx